module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.1543/img/callout-wave.svg"